<template class="">
  <div>
    <div v-if="commodityDetail.state == 'SELLING'">
      <div class="commodity-detail">
        <img
          class="background"
          :src="(commodityDetail.coverResource || {}).resUrl || 'https://image.xiaomaiketang.com/xm/kNYEN5Qiw6.png'"
        />
        <div class="info">
          <p class="name">{{commodityDetail.commodityName}}</p>
          <div class="price">
            <span class="unit">￥</span>
            <span class="money">{{moneyFormatGroup(currentPrice.currentPrice, 2)}}</span>
            <span class="number">{{(currentPrice.commoditySpecs || {}).containQuantity}}{{(currentPrice.commoditySpecs || {}).measurementUnits}}</span>
          </div>
        </div>
        <div class="empty"></div>
        <div class="select">
          <ul>
            <li
              v-for="(item, index) in priceList"
              :key="index"
              @click="changePrice(item.id)"
              :class="item.id == selected ? 'item selected' : 'item'"
            >
              <span class="tag">{{item.specName}}</span>
            </li>
          </ul>
        </div>
        <div class="empty"></div>
        <div class="detail">
          <div class="text">{{commodityDetail.description}}</div>
          <span class="word" @click="jumpToList">查看其他课程</span>
        </div>
        <button class="submit" @click="jumpToConfirm">立即购买</button>
      </div>
    </div>
    <xm-empty-page
      v-else
      title="课程已下架"
      :src="emptyCourse"
      :onLoading="reload"
    >
    </xm-empty-page>
  </div>
</template>
<script>
import EmptyDataPage from "@/module/base/EmptyDataPage";
import emptyCourse from "@/images/no_message_schedule.png";
import { moneyFormatGroup } from '../../core/filters';
import WechatApi from '@/core/wechatApi';
import User from "@/core/user";
import Service from '../../service/Service';

export default {
  components: {
    xmEmptyPage: EmptyDataPage,
  },

  data() {
    return {
      commodityDetail: { state: 'SELLING' },
      priceList: [],
      currentPrice: {},
      selected: '',
      reload: false,
      emptyCourse,
      moneyFormatGroup,
    };
  },
  methods: {
    fetchCommodityDetail() {
      const data = {
        commodityId: window.getParameterByName('commodityId'),
        instId: window.getParameterByName('mallInstId'),
      };
      axios.Customer('anon/courseCommodity/getDetailById', data).then((res) => {
        if (res.success) {
          this.commodityDetail = res.result.commodityDetailVO;
          this.priceList = res.result.commoditySpecShowVOList;
          this.currentPrice = this.priceList[0];
          this.selected = this.currentPrice.id;
        }
      })
    },

    changePrice(value) {
      this.selected = value;
      this.currentPrice = _.find(this.priceList, item => item.id == value);
    },

    jumpToList() {
      if (window.getParameterByName('preview')) return;
      this.$router.push({
        name: 'course_mall',
        query: {
          mallInstId: window.getParameterByName('mallInstId'),
          studentId: window.getParameterByName('studentId'),
        },
      });
    },

    jumpToConfirm() {
      if (window.getParameterByName('preview')) return;
      this.$router.push({
        name: 'order_confirm',
        query: {
          mallInstId: window.getParameterByName('mallInstId'),
          studentId: window.getParameterByName('studentId'),
          commodityId: window.getParameterByName('commodityId'),
          specId: this.selected,
        }
      });
    },

    doShare() {
      const list = User.getInstList();
      const inst = _.find(list, item => item.instId == window.getParameterByName('mallInstId'));
      inst && WechatApi.doWapShare({
        title: `${inst.instName}有购课商城啦！`,
        desc: '线上购课，微信支付，免去排队烦恼，快来看看~~',
        linkUrl: location.origin + location.pathname + '#/mall/buyer?appid=' + User.appId() + '&mallInstId=' + inst.instId,
        imgUrl: inst.banner || 'https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png',
      });
      inst && wx.miniProgram.postMessage({ data: {
        title: `${inst.instName}有购课商城啦！`,
        desc: '线上购课，微信支付，免去排队烦恼，快来看看~~',
        linkUrl: location.origin + location.pathname + '#/mall/buyer?appid=' + User.appId() + '&mallInstId=' + inst.instId,
        imgUrl: inst.banner || 'https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png',
      } })
    },
  },

  mounted() {
    this.fetchCommodityDetail();
    this.doShare();
     wx.hideMenuItems({
      menuList: ["menuItem:copyUrl"] // 要显示的菜单项，所有menu项见附录3
    });

  },
}
</script>

<style lang="less">
  .commodity-detail {
    background: #fff;
    padding-bottom: 1.08rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    .background {
      width: 100vw;
      height: 50vw;
      object-fit: cover;
      display: block;
    }
    .empty {
      height: 0.2rem;
      width: 100%;
      background: #F4F6FA;
    }
    .info {
      padding: 0.3rem 0.32rem 0.12rem;
      .name {
        font-size: 0.36rem;
        color: #333;
        line-height: 0.5rem;
        font-weight: 500;
        margin-bottom: 0.14rem;
        text-align: left;
      }
      .price {
        display: flex;
        align-items: baseline;
        .unit {
          font-size: 0.3rem;
          color: #FF8534;
          line-height: 0.42rem;
        }
        .money {
          font-size: 0.48rem;
          color: #FF8534;
          line-height: 0.66rem;
        }
        .number {
          font-size: 0.28rem;
          color: #999;
          line-height: 0.4rem;
          margin-left: 0.24rem;
        }
      }
    }
    .select {
      padding: 0.32rem;
      padding-bottom: 0.08rem;
      ul {
        text-align: left;
        .item {
          display: inline-block;
          margin-right: 0.16rem;
          margin-bottom: 0.24rem;
          &.selected {
            .tag {
              color: #3296FA;
              border-color: #3296FA;
            }
          }
          .tag {
            padding: 0.04rem 0.16rem;
            color: #999;
            border: 1px solid #ddd;
            border-radius: 0.08rem;
            font-size: 0.28rem;
            line-height: 0.4rem;
          }
        }
      }
    }
    .detail {
      padding: 0.4rem 0.32rem 1rem;
      position: relative;
      .text {
        white-space: pre-wrap;
        text-align: left;
        color: #999;
        font-size: 0.26rem;
        line-height: 0.4rem;
        display: block;
      }
      .word {
        position: absolute;
        color: #3296FA;
        font-size: 0.26rem;
        bottom: 0.32rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .submit {
      border: none;
      margin: 0.1rem 0.3rem;
      color: #fff;
      background: #3296FA;
      height: 0.88rem;
      line-height: 0.88rem;
      border-radius: 0.1rem;
      font-size: 0.3rem;
      position: fixed;
      bottom: 0;
      left: 0;
      width: ~'calc(100% - 0.6rem)';
    }
  }
</style>


// WEBPACK FOOTER //
// src/module/mall/CommodityDetail.vue